import { ERRORS } from "../../../../../constants/errors";
import { caseInsensitiveRegex } from "./regex";
import type { Validator } from "./types";

export const postcode: Validator = ({ name, answer, questionErrorMessage }) => {
  // This regex is a direct replica of the Ruby version
  // https://github.com/simplybusiness/riddler/blob/master/lib/vendor/postcodr.rb#L8
  // http://en.wikipedia.org/wiki/Postcodes_in_the_United_Kingdom / github issue #13
  const expression =
    "^\\s*([A-Z]{1,2}[0-9R][0-9A-Z]?)\\s*(([0-9])([ABDEFGHJLNPQRSTUWXYZ]{2}))\\s*$";

  return caseInsensitiveRegex({
    name,
    answer,
    validation: {
      type: "regex",
      value: expression,
    },
    questionErrorMessage,
    fallbackMessage: ERRORS.INVALID_POSTCODE,
  });
};
